import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { StateNames } from '../models/vendor.model';
import { NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProgressBarService } from '../shared/progress-bar.service';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css', '../shared/css/common.css']
})
export class UserDetailsComponent implements OnInit {
  @ViewChild('emailVerificationModal') emailVerificationModal!: TemplateRef<any>;
  @ViewChild('verifyButtonBlock') verifyButtonBlock!: TemplateRef<any>;
  @ViewChild('verifyButtonOutlet', { read: ViewContainerRef }) verifyButtonOutlet!: ViewContainerRef;
  @ViewChild('contactTextBlock') contactTextBlock!: TemplateRef<any>;
  @ViewChild('contactTextOutlet', { read: ViewContainerRef }) contactTextOutlet!: ViewContainerRef;

  modalRef!: NgbModalRef;

  userFormDataPart1: any = {};
  userFormDataPart2: any = {};
  userFormDataPart3: any = {};
  userFormDataPart4: any = {};
  userFormPart1: FormGroup = this.userFormBuilder.group({});
  userFormPart2: FormGroup = this.userFormBuilder.group({});
  userFormPart3: FormGroup = this.userFormBuilder.group({});
  userFormPart4: FormGroup = this.userFormBuilder.group({});
  isInstruction: boolean = false;
  isformloaded = false;
  isFormsValid = false;
  isUrlsDisabled = false;
  formdata: any | null;
  statelist: StateNames[] = [];
  payorkey = 0;
  securityCode!: string | null;
  instructionText!: string | null;
  captchaValidated = false;
  verificationCode: string = '';
  verificationErrorMessage: string = '';
  isGeneratingCode: boolean = false;
  private routeSubscription!: Subscription;
  isReturningFromWitness = false;
  primaryColor?: string = "";
  isLoading: boolean = true;

  constructor(
    private userFormBuilder: FormBuilder,
    private router: Router,
    private referalService: ReferalFormService,
    private modalService: NgbModal,
    private cdref: ChangeDetectorRef,
    private vendorService: VendorService,
    private progressBarService: ProgressBarService
  ) {
    this.securityCode = router.url.replace("/", "");
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    sessionStorage.setItem("securityCode", this.securityCode);
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && this.modalRef) {
        this.modalRef.close();
      }
    });
  }

  ngOnInit(): void {
    this.isformloaded = false;

    const isFreshSession = !sessionStorage.getItem('sessionInitialized');
    const isReturningFromThanksCard =
      sessionStorage.getItem('returningFromThanksCard') === 'true' ||
      localStorage.getItem('isNewReferral') === 'true';

    const isReturningFromWitness =
      sessionStorage.getItem('returningFromWitness') === 'true';

    if (isFreshSession) {
      sessionStorage.setItem('sessionInitialized', 'true');
      this.clearStoredUserDetails();
      const defaultData = this.referalService.getFormLoadJSON();
      this.formdata = defaultData;
      localStorage.setItem('activeformdata', JSON.stringify(defaultData));
    }
    else if (isReturningFromWitness) {
      const savedFormData = localStorage.getItem('activeformdata');
      if (savedFormData) {
        this.formdata = JSON.parse(savedFormData);
      }
    }
    else {
      const savedFormData = localStorage.getItem('activeformdata');
      if (savedFormData) {
        this.formdata = JSON.parse(savedFormData);
      } else {
        const defaultData = this.referalService.getFormLoadJSON();
        this.formdata = defaultData;
        localStorage.setItem('activeformdata', JSON.stringify(defaultData));
      }
    }

    const controls = this.formdata.userDetails.controls;

    this.userFormDataPart1["controls"] = controls.slice(0, 5);
    this.userFormDataPart2["controls"] = controls.slice(5, 9);
    this.userFormDataPart3["controls"] = controls.slice(9, 10);
    this.userFormDataPart4["controls"] = controls.slice(10, 11);

    this.userFormPart1 = this.buildFormGroup(this.userFormDataPart1);
    this.userFormPart2 = this.buildFormGroup(this.userFormDataPart2);
    this.userFormPart3 = this.buildFormGroup(this.userFormDataPart3);
    this.userFormPart4 = this.buildFormGroup(this.userFormDataPart4);

    const emailControl = this.userFormDataPart2.controls.find(
      (ctrl: any) => ctrl.name === 'email'
    );

    if (emailControl) {
      emailControl.value = localStorage.getItem('userEmail') ?? '';

      if (isReturningFromWitness || isReturningFromThanksCard) {
        emailControl.readonly = false;
      }
    }

    this.updateFormValidity();
    this.loadFormInit(this.payorkey);

    setTimeout(() => {
      const colorFromStorage = localStorage.getItem('primaryCssColor');
      if (colorFromStorage) {
        this.primaryColor = colorFromStorage.toString();
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);

    this.userFormPart1.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart2.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart3.statusChanges.subscribe(() => this.updateFormValidity());
    this.userFormPart4.statusChanges.subscribe(() => this.updateFormValidity());

    this.progressBarService.sendData(true);
  }

  private buildFormGroup(formPartData: any): FormGroup {
    const group: any = {};
    formPartData.controls.forEach((ctrl: any) => {
      group[ctrl.name] = [ctrl.value || ''];
    });
    return this.userFormBuilder.group(group);
  }

  @HostListener('window:beforeunload')
    onBeforeUnload(): void {
      this.clearStoredUserDetails();
      sessionStorage.removeItem('sessionInitialized');
  }
  updateFormValidity() {
    const parts = [this.userFormPart1, this.userFormPart2, this.userFormPart3, this.userFormPart4];
    const allValid = parts.every(f => f.status === 'VALID');
    const newValidState = allValid;

    if (this.isFormsValid !== newValidState) {
      this.isFormsValid = newValidState;
      if(this.isFormsValid) {
        window.localStorage.setItem("UserDetailsFormValid", "true");
      }
      else {
        window.localStorage.removeItem("UserDetailsFormValid");
      }
      this.cdref.detectChanges();
    }
  }

  loadFormInit(payorkey: number) {
    this.isLoading = true;
    if (!payorkey) {
      this.vendorService.getPayorIdByCode(this.securityCode).subscribe((result) => {
        if (result == null) {
          this.isUrlsDisabled = true;
          return;
        }
        this.isUrlsDisabled = false;
        this.payorkey = result;
        sessionStorage.setItem("payorkey", this.payorkey.toString());
        this.loadData();
      });
    } else {
      this.loadData();
    }
  }

  private setOptionsIfExists(formPart: any, name: string, options: any[]) {
    const control = formPart.controls.find((x: any) => x.name === name);
    if (control) {
      control.options = options;
    } else {
      console.warn(`Control '${name}' for options not found.`);
    }
  }
  loadData() {
    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      const req = result;
      const isNewReferral = sessionStorage.getItem('returningFromThanksCard') === 'true' || localStorage.getItem('isNewReferral') === 'true';

      this.applyValidators(this.userFormPart1, "firstName", req.ReferringPartyFirstName);
      this.applyValidators(this.userFormPart1, "lastName", req.ReferringPartyLastName);
      this.applyValidators(this.userFormPart1, "title", req.ReferringPartyTitle);
      this.applyValidators(this.userFormPart1, "phone", req.ReferringPartyPhoneNumber);
      this.applyValidators(this.userFormPart2, "address1", req.MailingAddressStreet);
      this.applyValidators(this.userFormPart2, "city", req.MailingAddressCity);
      this.applyValidators(this.userFormPart3, "state", req.MailingAddressState);
      this.applyValidators(this.userFormPart4, "zip", req.MailingAddressZIP);

      if (isNewReferral) {
        this.applyValidators(this.userFormPart1, "orgName", true);
        this.applyValidators(this.userFormPart2, "email", true);

        const orgCtrl = this.userFormPart1.get('orgName');
        if (orgCtrl) {
          orgCtrl.setValidators([Validators.required]);
          orgCtrl.markAsTouched();
          orgCtrl.markAsDirty();
          orgCtrl.updateValueAndValidity({ emitEvent: true });
          this.userFormPart1.updateValueAndValidity({ emitEvent: true });
        }

        const saved = JSON.parse(localStorage.getItem('activeformdata') || '{}');
        const orgUi = saved?.userDetails?.controls?.find((c: any) => c.name === 'orgName');
        if (orgUi) {
          orgUi.required = true;
          if (!orgUi.validators) orgUi.validators = {};
          orgUi.validators.required = true;
        }
        const emailUi = saved?.userDetails?.controls?.find((c: any) => c.name === 'email');
        if (emailUi) {
          emailUi.required = false;
          if (emailUi.validators) emailUi.validators.required = false;
        }
        localStorage.setItem('activeformdata', JSON.stringify(saved));
      } else {
        this.applyValidators(this.userFormPart2, "email", true);
        this.applyValidators(this.userFormPart1, "orgName", req.ReferringPartyOrganizationAgencyName);
      }

      this.userFormPart1.updateValueAndValidity({ emitEvent: true });
      this.userFormPart2.updateValueAndValidity({ emitEvent: true });
      this.userFormPart3.updateValueAndValidity({ emitEvent: true });
      this.userFormPart4.updateValueAndValidity({ emitEvent: true });

      [this.userFormDataPart1, this.userFormDataPart2, this.userFormDataPart3, this.userFormDataPart4]
        .forEach(part => {
          part.controls.forEach((ctrl: any) => {
            const formControl =
              this.userFormPart1.get(ctrl.name) ||
              this.userFormPart2.get(ctrl.name) ||
              this.userFormPart3.get(ctrl.name) ||
              this.userFormPart4.get(ctrl.name);

            if (formControl) {
              const hasRequired = formControl.hasValidator(Validators.required);
              ctrl.required = hasRequired;
              if (!ctrl.validators) ctrl.validators = {};
              ctrl.validators.required = hasRequired;
            }
          });
        });

      this.cdref.detectChanges();
      this.updateFormValidity();

      this.isformloaded = true;

      if (localStorage.getItem('returningFromWitness') === 'true') {
        const emailFormControl = this.userFormPart2.get('email');
        if (emailFormControl) emailFormControl.disable();
      }

      localStorage.setItem("primaryCssColor", result.CssColor);
      this.primaryColor = result.CssColor;
      document.documentElement.style.setProperty('--primary-color', this.primaryColor);
    });

    this.vendorService.getReferringSourcesLookup(this.payorkey).subscribe((result) => {
      const orgOptions = result.map(x => ({ value: x.Id, key: x.Title }));
      this.setOptionsIfExists(this.userFormDataPart1, "orgName", orgOptions);
      setTimeout(() => {
        const orgNameValue = this.userFormDataPart1.controls.find((ctrl: any) => ctrl.name === 'orgName').value;
        if (orgNameValue) {
          (this.userFormPart1.get('orgName') as any)?.setValue(orgNameValue);
        }
        this.updateFormValidity();
      }, 10);
    });

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      this.instructionText = result.Instruction.replace('<img ', '<img title="Header" ');
    });

    this.vendorService.getStateNames().subscribe((result) => {
      this.statelist = result;
      const stateOptions = this.statelist.map(x => ({ value: x.Abbreviation, key: x.Name }));
      this.setOptionsIfExists(this.userFormDataPart3, "state", stateOptions);

      if (sessionStorage.getItem('returningFromThanksCard') === 'true') {
        const orgCtrl = this.userFormPart1.get('orgName');
        if (orgCtrl) orgCtrl.setValue('');
        const saved = JSON.parse(localStorage.getItem('activeformdata') || '{}');
        const orgUi = saved?.userDetails?.controls?.find((c: any) => c.name === 'orgName');
        if (orgUi) orgUi.value = '';
        localStorage.setItem('activeformdata', JSON.stringify(saved));
        sessionStorage.removeItem('returningFromThanksCard');
      }


      setTimeout(() => {
        this.updateFormValidity();
        this.cdref.detectChanges();
      }, 250);
      this.isLoading = false;
      if(this.verifyButtonOutlet != null) {
        this.verifyButtonOutlet.createEmbeddedView(this.verifyButtonBlock);
      }
      if(this.contactTextOutlet != null) {
        this.contactTextOutlet.createEmbeddedView(this.contactTextBlock);
      }
    });

    const body = document.querySelector('body');
    if (body) body.classList.remove('preload');
  }

  userDetailsSubmit() {
    if (
      this.userFormPart1.valid &&
      this.userFormPart2.valid &&
      this.userFormPart3.valid &&
      this.userFormPart4.valid
    ) {
      const zipModel = this.userFormDataPart4.controls.find((c: any) => c.name === 'zip');
      if (zipModel) zipModel.value = this.userFormPart4.get('zip')?.value || '';
      const tempArr = {
        controls: [
          ...this.userFormDataPart1.controls,
          ...this.userFormDataPart2.controls,
          ...this.userFormDataPart3.controls,
          ...this.userFormDataPart4.controls
        ]
      };

      const existingFormDataStr = localStorage.getItem('activeformdata');
      let fullFormData = existingFormDataStr ? JSON.parse(existingFormDataStr) : {};
      fullFormData.userDetails = tempArr;
      localStorage.setItem('activeformdata', JSON.stringify(fullFormData));
      const existingFormDataSessionstorage = sessionStorage.getItem('activeformdata');
      if (existingFormDataSessionstorage) {
        const sessionFormData = JSON.parse(existingFormDataSessionstorage);
        sessionFormData.userDetails = tempArr;
        sessionStorage.setItem('activeformdata', JSON.stringify(sessionFormData));
      }

      const emailControl = this.userFormDataPart2.controls.find((ctrl: any) => ctrl.name === 'email');
      if (emailControl?.value) localStorage.setItem('userEmail', emailControl.value);

      this.progressBarService.sendData(true);
      localStorage.setItem('returningFromUser', 'true');
      localStorage.removeItem('isNewReferral');
      if(this.isFormsValid) {
        window.sessionStorage.setItem("UserDetailsFormValid", "true");
      }
      else {
        window.sessionStorage.removeItem("UserDetailsFormValid");
      }
      
      this.router.navigate(['witness']);
    }
  }



  openInstruction() {
    const result = this.modalService.open(InstructionsComponent, {
      size: 'lg',
      ariaLabelledBy: 'Instructions'
    });
    result.componentInstance.name = this.instructionText;
  }

  valueChangeEvent(_: any) {
    setTimeout(() => {
      this.updateFormValidity();
      this.cdref.detectChanges();
    }, 50);

    const currentEmail = this.userFormPart2.get('email')?.value;
    const validatedEmail = sessionStorage.getItem('validatedEmail');
    if (currentEmail && validatedEmail && currentEmail !== validatedEmail) {
      sessionStorage.removeItem('emailValidated');
      sessionStorage.removeItem('validatedEmail');
    }
  }

  openEmailVerificationModal() {
    const emailControl = this.userFormPart2.get('email');
    const email = emailControl?.value;

    if (!email || !email.includes('@')) {
      alert('Please enter a valid email address before proceeding.');
      return;
    }
    const validatedEmail = localStorage.getItem('validatedEmail');
    const emailValidated = localStorage.getItem('emailValidated') === 'true';

    if (emailValidated && validatedEmail === email) {
      this.userDetailsSubmit();
      return;
    }
    this.isGeneratingCode = true;
    this.verificationCode = '';
    this.verificationErrorMessage = '';

    this.vendorService.generateCode(email).subscribe({
      next: () => {
        this.modalRef = this.modalService.open(this.emailVerificationModal, {
          windowClass: 'custom-wide-modal',
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      },
      error: () => {
        this.isGeneratingCode = false;
        alert('Error generating verification code. Please try again later.');
      }
    });
  }



  closeEmailVerificationModal() {
    if (this.modalRef) {
      this.modalRef.close();
      this.isGeneratingCode = false;
    }
  }

  onCaptchaResolved(response: string) {
    this.captchaValidated = !!response;
  }

  submitVerificationCode() {
    const email = this.userFormPart2.get('email')?.value;
    if (!this.isCodeValid() || !email) {
      alert('Please enter a valid 6-digit code.');
      return;
    }

    const payload = {
      authCode: this.verificationCode,
      email: email
    };

    this.vendorService.validateCode(payload).subscribe({
      next: (isValid) => {
        if (isValid) {
          this.verificationErrorMessage = '';
          sessionStorage.setItem('emailValidated', 'true');
          sessionStorage.setItem('validatedEmail', email);
          this.closeEmailVerificationModal();
          this.userDetailsSubmit();
        } else {
          this.verificationErrorMessage = 'Error! The value entered does not match the code sent to your email.';
        }
      },
      error: () => {
        alert('An error occurred while verifying the code. Please try again.');
      }
    });
  }


  resendCode() {
    const email = this.userFormPart2.get('email')?.value;
    if (!email || !email.includes('@')) {
      alert('Please enter a valid email address.');
      return;
    }
    this.verificationErrorMessage = '';
    this.verificationCode = '';
    this.isGeneratingCode = true;
    this.vendorService.generateCode(email).subscribe({
      next: () => {
        this.isGeneratingCode = false;
      },
      error: () => {
        this.isGeneratingCode = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  isCodeValid(): boolean {
    return /^\d{6}$/.test(this.verificationCode);
  }

  get isEmailPreviouslyValidated(): boolean {
    return sessionStorage.getItem('emailValidated') === 'true';
  }

  get isEmailValidatedAndSame(): boolean {
    const currentEmail = this.userFormPart2.get('email')?.value;
    const validatedEmail = sessionStorage.getItem('validatedEmail');
    const emailValidated = sessionStorage.getItem('emailValidated') === 'true';
    return emailValidated && currentEmail === validatedEmail;
  }

  private applyValidators(form: FormGroup, field: string, required: boolean) {
    {
      const control = form.get(field);
      if (!control) return;

      control.clearValidators();
      const validators: any[] = [];
      if (required) {
        validators.push(Validators.required);
        if (field === 'email') {
          validators.push(Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/));
        }
      }
      if (field === 'zip') {
        validators.push(Validators.pattern(/^\d{5}([-\s]?\d{4})?$/));
      }
      control.setValidators(validators.length > 0 ? validators : null);
      control.updateValueAndValidity({ emitEvent: false });
      const allParts = [
        this.userFormDataPart1.controls,
        this.userFormDataPart2.controls,
        this.userFormDataPart3.controls,
        this.userFormDataPart4.controls,
      ];

      for (const part of allParts) {
        this.syncRequiredFlag(form, field, part);
      }
    }
  }
  private syncRequiredFlag(form: FormGroup, field: string, uiControls: any[]) {
    const ctrl = form.get(field);
    const ui = uiControls.find(c => c.name === field);
    if (ui && ctrl) {
      const hasRequired = ctrl.hasValidator(Validators.required);
      ui.required = hasRequired;
      if (!ui.validators) ui.validators = {};
      ui.validators.required = hasRequired;
    }
  }
  private clearStoredUserDetails(): void {
    localStorage.removeItem('activeformdata');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('validatedEmail');
    localStorage.removeItem('emailValidated');
    localStorage.removeItem('isNewReferral');

    sessionStorage.removeItem('activeformdata');
    sessionStorage.removeItem('returningFromThanksCard');
    sessionStorage.removeItem('returningFromWitness');
    sessionStorage.removeItem('emailValidated');
    sessionStorage.removeItem('validatedEmail');
  }
}
